import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FiSearch } from "react-icons/fi";
import axios from "axios";
import { server } from "../server";

export default function RequestLogs() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [selectedMethod, setSelectedMethod] = useState("");
  const [logs, setLogs] = useState([]);
  const [error, setError] = useState("");
  const [pageSize, setPageSize] = useState(50);
  const [loading, setLoading] = useState(false);

  const [count, setCount] = useState(0);
  const [todayCount, setTodayCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);

  const token = localStorage.getItem("janToken");

  // Fetch Logs
  const fetchLogs = async (page = 1) => {
    try {
      setLoading(true);
      setError("");
      const { data } = await axios.get(`${server}/requestLogs/all`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          pageNo: page,
          pageSize: pageSize,
        },
      });

      setLogs(data?.data || []);
      setCount(data?.count || 0);
      setTodayCount(data?.todaysLog || 0);
      setTotalCount(data?.totalLogs || 0);
    } catch (err) {
      setError("Failed to fetch logs.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs(pageNo);
  }, [pageNo, pageSize]);

  const filteredLogs = logs.filter((log) => {
    return (
      log.apiUrl?.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (selectedUser === "" || String(log.userId) === selectedUser) &&
      (selectedModule === "" ||
        log.apiUrl.toLowerCase().includes(selectedModule.toLowerCase())) &&
      (selectedMethod === "" ||
        log.apiMethod.toLowerCase() === selectedMethod.toLowerCase())
    );
  });

  const uniqueUsers = Array.from(
    new Set(logs?.map((log) => `${log.userId} - ${log.userName}`))
  );

  const uniqueModules = Array.from(
    new Set(logs?.map((log) => log.apiUrl?.split("/")[1]))
  );

  const totalPages = Math.ceil(count / pageSize);

  return (
    <motion.div
      className="p-8 bg-gray-50 min-h-screen"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <h1 className="text-3xl font-bold text-gray-800 mb-6">
        API Request Logs.
      </h1>

      <div>
        <div>Total Logs Count : {totalCount.toLocaleString("en-In")}</div>
        <div>Today's Logs Count : {todayCount}</div>
      </div>

      <div className="sticky top-20 z-20 p-2 bg-gray-50">
        {/* Filter Controls */}
        {/* <div className="bg-white rounded-lg shadow-lg p-6 mb-6 grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="flex items-center border rounded-lg shadow-sm px-4 py-2 bg-gray-50">
            <FiSearch className="text-gray-400 mr-3" size={20} />
            <input
              type="text"
              placeholder="Search by URL"
              className="bg-gray-50 focus:outline-none w-full"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <select
            className="border rounded-lg shadow-sm px-4 py-2 bg-gray-50"
            value={selectedUser}
            onChange={(e) => setSelectedUser(e.target.value)}
          >
            <option value="">All Users</option>
            {uniqueUsers?.map((user) => (
              <option key={user} value={user.split(" - ")[0]}>
                {user}
              </option>
            ))}
          </select>

          <select
            className="border rounded-lg shadow-sm px-4 py-2 bg-gray-50"
            value={selectedModule}
            onChange={(e) => setSelectedModule(e.target.value)}
          >
            <option value="">All Modules</option>
            {uniqueModules?.map((module) => (
              <option key={module} value={module}>
                {module}
              </option>
            ))}
          </select>

          <select
            className="border rounded-lg shadow-sm px-4 py-2 bg-gray-50"
            value={selectedMethod}
            onChange={(e) => setSelectedMethod(e.target.value)}
          >
            <option value="">All Methods</option>
            <option value="get">GET</option>
            <option value="post">POST</option>
            <option value="put">PUT</option>
            <option value="delete">DELETE</option>
          </select>
        </div> */}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center space-x-2 my-6">
            <button
              className={`px-3 py-1 rounded ${
                pageNo === 1
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-gray-200 text-gray-700"
              }`}
              disabled={pageNo === 1}
              onClick={() => setPageNo(pageNo - 1)}
            >
              Previous
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter(
                (page) =>
                  page === 1 ||
                  page === totalPages ||
                  (page >= pageNo - 1 && page <= pageNo + 1)
              )
              .map((page, idx, arr) => (
                <React.Fragment key={page}>
                  {idx > 0 && page - arr[idx - 1] > 1 && (
                    <span className="px-2 text-gray-500">...</span>
                  )}
                  <button
                    className={`px-3 py-1 rounded ${
                      pageNo === page
                        ? "bg-blue-600 text-white"
                        : "bg-gray-200 text-gray-700"
                    }`}
                    onClick={() => setPageNo(page)}
                  >
                    {page}
                  </button>
                </React.Fragment>
              ))}

            <button
              className={`px-3 py-1 rounded ${
                pageNo === totalPages
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-gray-200 text-gray-700"
              }`}
              disabled={pageNo === totalPages}
              onClick={() => setPageNo(pageNo + 1)}
            >
              Next
            </button>
          </div>
        )}

        {/* Page Size Selector */}
        <div className="flex w-fit items-center space-x-4 mt-4 justify-center">
          <div className="text-gray-700 w-full">Rows per page:</div>
          <select
            className="border rounded-lg shadow-sm px-4 py-2 bg-gray-50"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setPageNo(1); // Reset to first page when page size changes
            }}
          >
            {[10, 25, 50, 100].map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>
      </div>
      {/* Logs Table */}
      <div className="overflow-x-auto overflow-hidden grid">
        <table className="min-w-full bg-white shadow-lg rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              {[
                "ID",
                "Method",
                "API URL",
                "Response Code/Type",
                "Created At",
                "Query",
                "User",
              ].map((header) => (
                <th
                  key={header}
                  className="text-left px-6 py-3 text-gray-600 uppercase text-sm tracking-wider"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="text-center py-6 text-gray-500">
                  Loading logs...
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="7" className="text-center py-6 text-red-500">
                  {error}
                </td>
              </tr>
            ) : logs?.length > 0 ? (
              logs?.map((log, idx) => (
                <motion.tr
                  key={log.id}
                  whileHover={{ scale: 1.01 }}
                  className={`${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
                >
                  <td className="px-6 py-4 text-gray-700">{log.id}</td>
                  <td className="px-6 py-4 text-gray-700 font-medium">
                    {log.method}
                  </td>
                  <td className="px-6 py-4 text-blue-600">{log.path}</td>
                  <td className="px-6 py-4 text-gray-700">
                    ({log.statusCode}) {log.status}
                  </td>
                  <td className="px-6 py-4 text-gray-500 text-sm">
                    {new Date(log.createdAt).toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-gray-700">{log.query}</td>
                  <td className="px-6 py-4 text-gray-700">{log.userId}</td>
                </motion.tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-6 text-gray-500">
                  No logs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </motion.div>
  );
}
